import React, { useState, useEffect } from 'react'
import { WidgetContent, Divider, TextField } from '@duik/it'
import CreateNewModal from '../../UI/CreateNewModal'
import { ModalButton } from '../../UI/ModalButton'
import FormInputGroup from '../../UI/FormInputGroup'
import * as Yup from 'yup'
import { Formik, ErrorMessage } from 'formik'
import EditSiteMap from './Maps/EditSiteMap'
import SiteViewModal from './SiteViewModal'

const ViewGeofencedSite = props => {
  const [locationScreen, setLocationScreen] = useState(false)
  const [siteName, setSiteName] = useState('')
  const [location, setLocation] = useState('')
  const [city, setCity] = useState('')
  const [province, setProvince] = useState('')
  const [coordinates, setCoordinates] = useState('')
  const [radius, setRadius] = useState()
  const [customCoordinates, setCustomCoordinates] = useState([])
  const [siteEditable, setSiteEditable] = useState(false)

  const toggleSiteEditable = () => {
    setSiteEditable(!siteEditable)
  }

  const screenToggle = () => {
    setLocationScreen(!locationScreen)
  }

  const locationCoordinatesEntry = (customCoordinates, siteCenter, radius) => {
    const coordinateString = 'Custom Geo-fence'
    setLocation(coordinateString)
    setCoordinates(siteCenter)
    setRadius(radius)
    setCustomCoordinates(customCoordinates)
    screenToggle()
  }

  const editSite = values => {
    const { _id } = props.siteViewDetail
    const { siteName, company } = values
    props.editSite(
      _id,
      siteName,
      company,
      location,
      city,
      province,
      coordinates,
      customCoordinates,
      radius
    )
    props.geofencedSiteViewModalToggle()
  }

  useEffect(() => {
    if (props.siteViewDetail) {
      const {
        siteName,
        location,
        city,
        province,
        coordinates,
        radius,
        customCoordinates
      } = props.siteViewDetail
      setSiteEditable(props.siteIsEditable)
      setSiteName(siteName)
      setLocation(location)
      setCity(city)
      setProvince(province)
      setCoordinates(coordinates)
      setRadius(radius)
      setCustomCoordinates(customCoordinates)
    }
  }, [props])

  if (!siteName || !coordinates || !radius || !customCoordinates) return null
  if (!locationScreen) {
    return (
      <CreateNewModal
        title={siteEditable ? 'Edit Site' : siteName}
        bannerText={
          siteEditable
            ? 'Press Save when finished updating all information'
            : 'Press Edit to update site name, company or geo-fence'
        }
        handleCloseModal={props.geofencedSiteViewModalToggle}
      >
        <Formik
          initialValues={{
            siteName: (props.siteViewDetail && props.siteViewDetail.siteName) || '',
            company: (props.siteViewDetail && props.siteViewDetail.company) || ''
          }}
          validationSchema={SiteSchema}
          handleSubmit={e => console.log('')}
          onSubmit={values => {
            editSite(values)
          }}
          render={({
            values,
            errors,
            handleBlur,
            handleChange,
            handleSubmit,
            isSubmitting,
            setFieldValue,
            touched
          }) => (
            <form onSubmit={handleSubmit}>
              <WidgetContent>
                <FormInputGroup>
                  <FormInputGroup horizontal>
                    <div>
                      <TextField
                        className="fullWidthInputBox"
                        label="Site Name"
                        name="siteName"
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={values.siteName}
                        disabled={!siteEditable}
                      />
                      <ErrorMessage
                        name="siteName"
                        render={msg => (
                          <span
                            style={{
                              position: 'absolute',
                              color: '#E6492D',
                              fontSize: '0.75rem'
                            }}
                          >
                            {msg}
                          </span>
                        )}
                      />
                    </div>
                  </FormInputGroup>
                  <FormInputGroup horizontal>
                    <div style={{ marginBottom: '40px', marginTop: '16px' }}>
                      <TextField
                        className="fullWidthInputBox"
                        label="Company"
                        name="company"
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={values.company}
                        disabled={!siteEditable}
                      />
                      <ErrorMessage
                        name="company"
                        render={msg => (
                          <span
                            style={{
                              position: 'absolute',
                              color: '#E6492D',
                              fontSize: '0.75rem'
                            }}
                          >
                            {msg}
                          </span>
                        )}
                      />
                    </div>
                  </FormInputGroup>
                </FormInputGroup>
              </WidgetContent>
              <Divider />
              <WidgetContent
                style={{
                  display: 'flex',
                  justifyContent: 'center',
                  padding: '40px 0',
                  backgroundColor: '#FBFBFD'
                }}
              >
                <div style={{ width: '161px' }}>
                  <ModalButton
                    name={siteEditable ? 'Draw Geo-Fence' : 'View Geo-Fence'}
                    onClick={screenToggle}
                  />
                </div>
              </WidgetContent>
              <WidgetContent style={{ display: 'flex', justifyContent: 'space-between' }}>
                <div style={{ width: '83px' }}>
                  <ModalButton
                    buttonStyle="tertiary"
                    name={siteEditable ? 'Cancel' : 'Edit'}
                    onClick={toggleSiteEditable}
                    disabled={props.companyId !== props.siteViewDetail.companyId}
                  />
                </div>
                <div style={{ width: '83px' }}>
                  <ModalButton
                    success
                    type={siteEditable ? 'submit' : undefined}
                    disabled={isSubmitting}
                    name={siteEditable ? 'Save' : 'OK'}
                  />
                </div>
              </WidgetContent>
            </form>
          )}
        />
      </CreateNewModal>
    )
  } else if (siteEditable) {
    return (
      <EditSiteMap
        customCoordinates={customCoordinates}
        radius={radius}
        screenToggle={screenToggle}
        coordinates={coordinates}
        locationCoordinatesEntry={locationCoordinatesEntry}
      />
    )
  } else {
    return (
      <SiteViewModal siteViewModalToggle={screenToggle} siteViewDetail={props.siteViewDetail} />
    )
  }
}

export default ViewGeofencedSite

const SiteSchema = Yup.object().shape({
  siteName: Yup.string()
    .min(2, 'Too Short!')
    .max(30, 'Too Long!')
    .required('Required'),
  company: Yup.string()
    .min(2, 'Too Short!')
    .max(30, 'Too Long!')
    .required('Required')
})
